/* eslint-disable no-param-reassign */
import axios from 'axios';
import urlData from '../config';

const request = async (params) => {
    const { url, method = 'get', data = {}, headers = {}, token = '' } = params;

    try {
        // Resolve each call so LAN/phone rewrite in config.js always applies.
        const base = String(urlData.SERVER_URL || '').replace(/\/?$/, '/');
        const fullUrl = `${base}${url}`;

        if (token) headers.Authorization = `Bearer ${token}`;

        const response = await axios({
            method,
            headers,
            url: fullUrl,
            data,
        });

        return { error: '', data: response.data, status: '' };
    } catch (err) {
        return { error: err, data: '', status: err.response?.status };
    }
};

export default request;
